import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { blue, red, textMuted, white } from '@/theme/colors'
import { shadows, radii } from '@/theme/tokens'
import { fontSizes, text } from '@/theme/typography'
import { Pill } from '@components/Pill'

/** Shared styles for the read-only admin detail pages (User, Trip, Event, Idea, Expense). */

export const BackLink = styled(Link)`
	display: inline-block;
	margin-bottom: 16px;
	color: ${blue};
	text-decoration: none;
	font-weight: 700;
	font-size: ${fontSizes.small};

	&:hover {
		text-decoration: underline;
	}
`

export const DetailHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;
	margin-bottom: 24px;
`

export const DetailTitle = styled.h1`
	margin: 0;
	font-size: ${fontSizes.headingLg};
	font-weight: 700;
	color: ${blue};
`

export const DeletedBadge = styled.span`
	display: inline-block;
	padding: 2px 8px;
	border-radius: ${radii.small};
	background-color: ${red};
	color: ${white};
	font-size: ${fontSizes.micro};
	font-weight: 700;
`

export const Card = styled.div`
	background-color: ${white};
	border-radius: ${radii.inner};
	box-shadow: ${shadows.inner};
	padding: 24px;
	margin-bottom: 20px;
`

export const CardTitle = styled.h2`
	margin: 0 0 16px;
	font-size: ${fontSizes.body};
	font-weight: 700;
	color: ${textMuted};
`

export const FieldGrid = styled.dl`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 16px 24px;
	margin: 0;
`

export const Field = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
`

export const FieldLabel = styled.dt`
	${text.eyebrow}
	color: ${textMuted};
`

export const FieldValue = styled.dd`
	margin: 0;
	font-size: ${fontSizes.body};
	color: ${blue};
	word-break: break-word;
`

export const InlineLink = styled(Link)`
	color: ${blue};
	font-weight: 700;
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}
`

export const RelatedList = styled.div`
	display: flex;
	flex-direction: column;
`

export const RelatedRow = styled(Link)<{ $deleted?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	padding: 12px 4px;
	border-bottom: 1px solid ${textMuted}14;
	text-decoration: none;
	color: ${blue};
	background-color: ${({ $deleted }) => ($deleted ? `${red}0d` : 'transparent')};

	&:last-child {
		border-bottom: none;
	}
	&:hover {
		background-color: ${blue}0d;
	}
`

export const RelatedMeta = styled.span`
	color: ${textMuted};
	font-size: ${fontSizes.small};
	white-space: nowrap;
`

export const Tag = styled(Pill).attrs({ $tone: 'coolSoft' as const })`
	margin: 0 6px 6px 0;
`

export const Chips = styled.div`
	display: flex;
	flex-wrap: wrap;
`


